import { Component } from '@angular/core';
import { ContainerComponent } from '../../modules/shared/components/container-component/unsubscribe.component';
import { IamoboService } from '../../core/services/iamobo.service';
import { ConfigService } from '../../modules/config/config.service';

@Component({
    template: require('./adfs-redirect.component.html')
})

/**
 * Component for obtaining ADFS2019 token with on-behalf-of cluid.
 */
export class AdfsRedirectComponent extends ContainerComponent {

    webApiClientId: string;
    adfsAuthorizeUrl: string;

    constructor(private iamoboService: IamoboService, private configService: ConfigService) {
        super();

        this.configService.load().subscribe(config => {

            this.webApiClientId = config.webApiClientId;
            this.adfsAuthorizeUrl = config.adfsAuthorize;

            let queryCluid = sessionStorage.getItem('queryCluid');
            let accessToken = sessionStorage.getItem('accessToken');
            let tokenUserId = sessionStorage.getItem('userId');

            if (accessToken !== 'null') {
                // url hash params contain 'access_token', call IAM OBO and set cluid context
                this.iamoboService.setUserContext(tokenUserId, queryCluid)
                    .subscribe(() => {
                        // redirect to adfs to get new token with on-behalf-of 'cluid'
                        window.location.assign(this.getAdfsUrl(queryCluid));
                    });
            } else {
                // url hash params does not contain 'access_token', redirect to adfs to get new token
                window.location.assign(this.getAdfsUrl(queryCluid));
            }
        });
    };

    getAdfsUrl(cluid: string) {
        return this.adfsAuthorizeUrl +
            '?response_type=token' +
            '&redirect=true' +
            '&client_id=' + this.webApiClientId +
            '&redirect_uri=' + window.location.origin + '/selfservice/applications/manage?cluid=' + cluid;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/adfs-redirect/adfs-redirect.component.ts